import { z } from 'zod';
import { zOrderLine } from './application';

export const zProductDetailItem = z.object({
  productNumber: z.string(),
  productDescription: z.string(),
  variant: z.string().nullable(),
  variantDescription: z.string().nullable(),
  imageUrl: z.string(),
  orderLines: zOrderLine.array(),
});

export const zProductListItem = z.object({
  productNumber: z.string(),
  productDescription: z.string(),
  variant: z.string().nullable(),
  variantDescription: z.string().nullable(),
  imageUrl: z.string(),
});

export const zProductsDetailResponse = z.object({
  details: zProductDetailItem.array(),
});

export const zProductSearchResponse = z.object({
  matches: zProductListItem.array(),
});

export type tProductSearchResponse = z.infer<typeof zProductSearchResponse>;
export type tProductListItem = z.infer<typeof zProductListItem>;
export type tProductDetailItem = z.infer<typeof zProductDetailItem>;
